import { Box } from '@mui/system';
import { StyledCommunixBundle } from './style';
import { BundleProps, ProductData } from 'utils/types';
import { BundlePrice } from 'components/BundlePrice';
import {
  EBadgePosition,
  EBadgeType,
  EBundlesInternalViewModel,
} from 'utils/enums';
import { RibbonBadge } from 'components/Badge/RibbonBadge/RibbonBadge';
import {
  BadgeData,
  EBadgeDesignType,
  IRibbonBadge,
} from 'components/Badge/types';
import { DefaultSaleBadge } from 'components/Badge/Sale/DefaultSaleBadge';
import { generateSalePercentageBasedOnType } from 'utils';
import { useGetBadge } from 'utils/useGetBadge';
import { useEffect, useState } from 'react';

export const Communix2Bundle: React.FC<BundleProps> = ({
  prices,
  fontFamily,
  productList,
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  bundleBorderColor,
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  borderRadius,
  inMobileMock = false,
  badges = [],
  ribbonBadges = [],
}) => {
  const [ribbonBadgeOld, setRibbonBadgeOld] = useState<any>(null);
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProduct, setSubProduct] = useState<ProductData[]>([]);
  const ribbonBadgeNew = useGetBadge<IRibbonBadge>(ribbonBadges);

  useEffect(() => {
    if (productList.length > 0) {
      setMainProduct(productList[0]);
    }
    if (productList.length > 1) {
      setSubProduct(productList.slice(1, 3));
    }
  }, [productList]);

  useEffect(() => {
    let foundRibbon;
    if (badges.length > 0) {
      if (badges[0].badge) {
        foundRibbon = badges?.find(
          (badge: BadgeData) =>
            (badge as BadgeData).badge?.type === EBadgeType.RIBBON,
        )?.badge as BadgeData;
        setRibbonBadgeOld(foundRibbon?.ribbon);
      } else {
        foundRibbon = badges?.find(
          (badge: BadgeData) => badge.type === EBadgeType.RIBBON,
        );
        setRibbonBadgeOld(foundRibbon?.ribbon);
      }
    }
  }, [badges]);

  const ribbonBadge = ribbonBadgeNew ?? ribbonBadgeOld;

  return (
    <StyledCommunixBundle
      fontFamily={fontFamily}
      productColor={mainProduct?.textFontColorHex || '#fff'}
      bundleButtonColor={bundleButtonColor}
      bundleBorderColor={bundleBorderColor}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      className="internal-bundle"
      borderRadius={borderRadius}
    >
      <Box className="container">
        <Box className="product">
          {mainProduct && (
            <>
              <Box className="amount">
                <Box
                  sx={{
                    lineHeight: '90%',
                  }}
                >
                  {mainProduct.images.productPrefix && (
                    <img src={mainProduct.images.productPrefix} alt="coin" />
                  )}
                  {mainProduct.quantityDisplay}
                </Box>
                <Box className="stroked">
                  {mainProduct.strokedSaleQuantity
                    ? mainProduct.strokedSaleQuantity
                    : ''}
                </Box>
              </Box>
              <Box className="image">
                <img alt="product" src={mainProduct.images.product} />
              </Box>
              {subProduct.length > 0 && (
                <div className="sub-products">
                  {subProduct.map(
                    ({ textFontColorHex, quantityDisplay, images }) => (
                      <Box
                        className="sub-product"
                        sx={{ color: textFontColorHex || '#fff' }}
                      >
                        <Box className="sub-product--background">
                          <Box className="sub-product--background__amount">
                            {quantityDisplay}
                          </Box>
                          <Box className="sub-product--background__image">
                            <img
                              className="sub-image"
                              src={images.product}
                              alt="coin"
                            />
                          </Box>
                        </Box>
                      </Box>
                    ),
                  )}
                </div>
              )}
            </>
          )}
          <BundlePrice
            prices={prices}
            buttonTextColor={bundleButtonTextColor}
            type={EBundlesInternalViewModel.COMMUNIX2}
            buttonColor={bundleButtonColor}
            borderRadius="0 0 9px 9px"
            textShadow="0 0 4px rgba(0,0,0, 0.5)"
            isPreview={inMobileMock}
            isTextAutoResized
          />
        </Box>
        {ribbonBadge && (
          <RibbonBadge
            {...ribbonBadge}
            position={EBadgePosition.CENTER}
            viewModel={EBundlesInternalViewModel.COMMUNIX2}
          />
        )}
      </Box>
    </StyledCommunixBundle>
  );
};
